import { observable, action, computed } from "mobx";

export default class RestAccessRequestStore {

  @observable
  restAccessRequestModalVisibilityMap = observable.map(
    {
      "po": false,
      "mao": false,
    }
  );

  @observable
  restAccessRequestUrlAndBid = {
    url: "",
    bid: ""
  };

  @action
  toggleRestAccessRequestModalVisibility = (parent) => {
    this.restAccessRequestModalVisibilityMap.set(
      parent, !this.restAccessRequestModalVisibilityMap.get(parent)
    );
  };

  @action
  updateRestAccessRequest = newBid => {
    this.restAccessRequestUrlAndBid = {
      bid: newBid,
      url: this.purgeAndFinalizeRestAccessUrl(window.location.href)
    };
  };

  purgeAndFinalizeRestAccessUrl = url => {
    const splittedUrl = url.split("//");
    const splittedSecondUrlPart = splittedUrl[1].split("/");
    return splittedUrl[0] + "//" + splittedSecondUrlPart[0] + "/query";
  };

  @computed
  get getRestAccessRequestData() {
    const data = [
      this.restAccessRequestUrlAndBid.url,
      {
        type: "Entity",
        filter: {
          type: "Entity",
          bid: {
            in: [this.restAccessRequestUrlAndBid.bid]
          }
        }
      }
    ];

    return data;
  }

  isRestAccessRequestModalVisible = (parent) => {
    return computed(() => this.restAccessRequestModalVisibilityMap.get(parent)).get();
  }
}
